import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import Upsert from '../../../components/form/Upsert'
import Table from '../../../components/layout/Table'
import Modal from '../../../components/popup/Modal'

const fields = ['kinhGui', 'congVanSo', 'ngay', 'file']
const required = ['kinhGui', 'congVanSo', 'ngay']
const name = { kinhGui: 'Kính gửi', congVanSo: 'Công văn số', ngay: 'Ngày', file: 'File đính kèm' }
const types = { ngay: 'date', file: 'file' }

export default function AddsTraCuu(props) {
  const { toggle, selected, save, visible } = props

  const [xacMinhVanBang, setXacMinhVanBang] = useState({})
  const [error, setError] = useState({})

  useEffect(() => {
    setXacMinhVanBang({})
  }, [visible])
  const column = [
    { value: 'hoTen', name: 'Họ tên' },
    { value: 'ngaySinh', name: 'Ngày sinh' },
    { value: 'noiSinh', name: 'Nơi sinh' },
    { value: 'khoaThi', name: 'Khoá thi', render: (item) => item.khoaThi.date },
  ]

  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button
        label="Huỷ"
        className="p-button-secondary mr-2"
        onClick={() => {
          if (toggle) toggle()
        }}
      />
      <Button
        onClick={() => {
          const newError = {}
          required.forEach((key) => {
            if (!fields.find((i) => key === i)) {
              return
            }
            if (
              xacMinhVanBang[key] === '' ||
              xacMinhVanBang[key] === undefined ||
              xacMinhVanBang[key] === null
            ) {
              newError[key] = `Trường ${name[key] || key} là bắt buộc!`
            }
          })
          setError(newError)
          if (Object.keys(newError).length === 0) {
            if (save) save(xacMinhVanBang)
            if (toggle) toggle()
          }
        }}
        label="Lưu"
      />
    </div>
  )

  const setup = {
    fields,
    name,
    types,
    required,
    error,
    values: xacMinhVanBang,
    setValues: setXacMinhVanBang,
  }
  return (
    <Modal {...props} width="80%" footer={footer} header="Danh sách xác nhận văn bằng">
      <div className="flex flex-column">
        <div className="flex justify-content-start">
          <h4>Thông tin cần bổ sung</h4>
        </div>
        <Upsert {...setup} />
        <div className="flex justify-content-start">
          <h4>Thông tin nội dung văn bằng</h4>
        </div>
        <Table data={selected} column={column} />
      </div>
    </Modal>
  )
}
